import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../services/common/token.service';
import { BaseService } from '../services/common/base.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaoService extends BaseService {

  protected http: HttpClient;

  constructor(http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this.http = http;
  }



  // InsertFarmerApplicationApprovalRemarks(appId: String, userId: String, remarks: String, statusValue: String) {
  //   return this.http.post(`${environment.apiUrl}DashBoard/InsertFarmerApplicationApprovalRemarks?AppId=${appId}&Userid=${userId}&Remarks=${remarks}&Status=${statusValue}`, {responseType: 'text'});
  // }

  getMISubsidyLotNos() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetMISubsidyLotNos`);
  }

  getMIPFMSExport(lotNo: string) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetMIPFMSExport?LotNo=${lotNo}`);
  }

  // getDataToPrintMultipleChallanAtal(userId: String) {
  //   return this.http.post(`${environment.apiUrl}Challan/GetDataToPrintMultipleChallanAtal?RequestType=${userId}`, {});
  // }


  miFarmerShareToVendorPFMSReport() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIFarmerShareToVendorPFMSReport`);
  }

  miSubsidyToVendorPFMSReport() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorPFMSReport`);
  }

  miSubsidyToFarmerPFMSReport() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerPFMSReport`);
  }

  miRefundToFarmerPFMSReport() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIRefundToFarmerPFMSReport`);
  }

  miFarmerShareToVendorPFMSExport(lotId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIFarmerShareToVendorPFMSExport?LotNo=${lotId}`);
  }

  miSubsidyToVendorPFMSExport(lotId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorPFMSExport?LotNo=${lotId}`);
  }

  miSubsidyToFarmerPFMSExport(lotId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerPFMSExport?LotNo=${lotId}`);
  }

  miRefundToFarmerPFMSExport(lotId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIRefundToFarmerPFMSExport?LotNo=${lotId}`);
  }

  importMIPFMSSubsidyToFarmer_Vendor(reqBody) {
    return this.http.post<any>(`${environment.apiUrl}Department/ImportMIPFMSSubsidyToFarmer_Vendor`, reqBody);
  }

  importMIPFMSFarmerShareToVendor_RefundToFarmer(reqBody) {
    return this.http.post<any>(`${environment.apiUrl}Department/ImportMIPFMSFarmerShareToVendor_RefundToFarmer`, reqBody);
  }

  importPondPFMSSubsidyToFarmer(reqBody) {
    return this.http.post<any>(`${environment.apiUrl}Department/ImportPFMSPond`, reqBody);
  }

  //Pond PFMS tank stage reports by Stage ID
  getApplicatonsForPondSubsidyPFMSReportsByStageId(stageId : any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondSubsidyToFarmerPFMSReport?Stage=${stageId}`);
  }  
  getApplicationsForPondFarmerShareToVendorPFMSExportByLotId(lotId, stageId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondFarmerShareToVendorPFMSExport?LotNo=${lotId}&Stage=${stageId}`);
  }

  getDataForLotCertificate(lotId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetDataForLotCertificate?LotNo=${lotId}`);
  }


}
